<template>
	<div class="page">
		<div class="nucleustit">
			<div class="tit">核心数据</div>
			<div>
				<!-- <el-date-picker style="width: 130px;margin-left: 10px;" size="mini" v-model="curDate1" type="date" value-format="timestamp" :picker-options="{disabledDate(date) {return date.getTime() > Date.now()}}" placeholder="选择日期" @change="changePicker" :clearable="false">
				</el-date-picker> -->
				<!-- <el-select size="mini" v-model="dateType" placeholder="请选择" style="width: 100px;margin-left: 10px;" @change="changeDateType">
					<el-option label="查看当日" value="date"></el-option>
					<el-option label="查看当周" value="week"></el-option>
					<el-option label="查看当月" value="month"></el-option>
				</el-select> -->
				<el-date-picker v-model="curDate1" @change="changeCurDate1" :clearable="false" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" size="mini">
				</el-date-picker>
			</div>
		</div>
		<div style="display: flex;">
			<div class="panel1">
				<div class="tit">
					<div>总活体销售</div>
					<div>
						<el-radio-group v-model="radio1" @change="changeRadio1">
							<el-radio :label="0">按数量对比</el-radio>
							<el-radio :label="1">销售额对比</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div id="myChartHuoti0" style="width:100%;height: 250px;"></div>
			</div>
			<div class="panel2">
				<div class="tit">
					<div>活体销售趋势图</div>
					<!-- <div>
						<div class="btn" :class="[curBtn2==='month'?'active':'']" @click="changeCurBtn2('month')">按月</div>
						<div class="btn" :class="[curBtn2==='year'?'active':'']" @click="changeCurBtn2('year')">按年</div>
						<el-date-picker style="width: 130px;margin-left: 10px;" size="mini" v-model="curDate2" type="date" value-format="timestamp" :picker-options="{disabledDate(date) {return date.getTime() > Date.now()}}" placeholder="选择日期" @change="changeCurDate2" :clearable="false">
						</el-date-picker>
					</div> -->
				</div>
				<div id="myChartHuoti1" style="width:100%;height: 250px;padding:0 20px;box-sizing: border-box;"></div>
			</div>
		</div>
		<div class="panel3">
			<div class="tit">
				累计门店活体销售数量/排名
			</div>
			<div style="display: flex;justify-content: space-between;padding:0 20px;height: 28px;;">
				<div>
					<el-radio-group v-model="radio3">
						<el-radio :label="0">门店销售数量</el-radio>
						<el-radio :label="1">活体销售排名</el-radio>
					</el-radio-group>
					<span v-if="radio3===0" style="font-size: 14px;margin-left:20px;">
						门店：
						<el-select style="width: 150px;margin-right:20px;" v-model="shopId3" placeholder="请选择" size='mini' @change="changeShopId3">
							<el-option v-for="item in datas.shopPetSexSaleDetails" :key='item.shopId' :label="item.shopName" :value="item.shopId">
							</el-option>
						</el-select>
					</span>
				</div>
				<div style="color:#F66400;cursor: pointer;" @click="$router.push({'path':'/huotishuju/huotiItem'})">
					查看更多 >
				</div>
			</div>
			<div v-if="radio3===0" style="display: flex;padding:20px;">
				<div class="panel3Cell">
					<div class="panel3CellL">
						<div class="panel3Cell1">公猫销售数据</div>
						<div class="panel3Cell2">{{curShopDatas.catMaleCount}}</div>
						<div class="panel3Cell3">￥{{curShopDatas.catMaleAmount}}</div>
					</div>
					<img class="panel3CellR" src="../../../assets/img/shuju/Group1.png">
				</div>
				<div class="panel3Cell">
					<div class="panel3CellL">
						<div class="panel3Cell1">母猫销售数据</div>
						<div class="panel3Cell2">{{curShopDatas.catFemaleCount}}</div>
						<div class="panel3Cell3">￥{{curShopDatas.catFemaleAmount}}</div>
					</div>
					<img class="panel3CellR" src="../../../assets/img/shuju/Group2.png">
				</div>
				<div class="panel3Cell">
					<div class="panel3CellL">
						<div class="panel3Cell1">公犬销售数据</div>
						<div class="panel3Cell2">{{curShopDatas.dogMaleCount}}</div>
						<div class="panel3Cell3">￥{{curShopDatas.dogMaleAmount}}</div>
					</div>
					<img class="panel3CellR" src="../../../assets/img/shuju/Group3.png">
				</div>
				<div class="panel3Cell">
					<div class="panel3CellL">
						<div class="panel3Cell1">母犬销售数据</div>
						<div class="panel3Cell2">{{curShopDatas.dogFemaleCount}}</div>
						<div class="panel3Cell3">￥{{curShopDatas.dogFemaleAmount}}</div>
					</div>
					<img class="panel3CellR" src="../../../assets/img/shuju/Group4.png">
				</div>
			</div>
			<div v-if="radio3===1" style="display: flex;padding:20px;">
				<div class="panel3Item">
					<div class="panel3ItemTit">
						活体性别销售数量最高
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestSexSale[1].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestSexSale[1].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestSexSale[1].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestSexSale[1].amount}}</div>
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestSexSale[2].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestSexSale[2].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestSexSale[2].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestSexSale[2].amount}}</div>
					</div>
				</div>
				<div class="panel3Item">
					<div class="panel3ItemTit">
						活体品种销售数量最高
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestCategorySale[1].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestCategorySale[1].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestCategorySale[1].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestCategorySale[1].amount}}</div>
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestCategorySale[2].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestCategorySale[2].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestCategorySale[2].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestCategorySale[2].amount}}</div>
					</div>
				</div>
				<div class="panel3Item">
					<div class="panel3ItemTit">
						活体年龄销售数量最高
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestAgeSale[1].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestAgeSale[1].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestAgeSale[1].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestAgeSale[1].amount}}</div>
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestAgeSale[2].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestAgeSale[2].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestAgeSale[2].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestAgeSale[2].amount}}</div>
					</div>
				</div>
				<div class="panel3Item" style="margin:0;">
					<div class="panel3ItemTit">
						活体售价销售数量最高
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestPriceSale[1].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestPriceSale[1].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestPriceSale[1].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestPriceSale[1].amount}}</div>
					</div>
					<div class="panel3ItemLine">
						<div style="font-size: 26px;line-height:7px;">{{datas.highestPriceSale[2].count}}</div>
						<div style="padding:0 10px 0 0;font-weight: bold;">(只/{{datas.highestPriceSale[2].petCategory}})</div>
						<div style="padding:0 10px;">{{datas.highestPriceSale[2].info}}</div>
						<!-- <div style="padding:0 10px;border-left:1px solid #BCBCBC;border-right: 1px solid #BCBCBC;">母</div> -->
						<div style="padding:0 10px;">￥{{datas.highestPriceSale[2].amount}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="panel4">
			<div class="tit">
				累计门店已售宠物列表
			</div>
			<div style="padding:0 0 0 20px;font-size: 14px;">
				<span style="padding-left:2px;">门店:</span>
				<el-select style="width: 90px;" v-model="shopId" placeholder="请选择" size='mini' @change="changeTableData">
					<el-option v-for="item in shopList" :key='item.shop_id' :label="item.shop_name" :value="item.shop_id">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">售价区间:</span>
				<el-input v-model="minPrice" @input="changeTableData" style="width:70px;" size="mini"></el-input> -
				<el-input v-model="maxPrice" @input="changeTableData" style="width:70px;" size="mini"></el-input>
				<span style="padding-left:2px;">种类:</span>
				<el-select style="width: 80px;" v-model="applyType" placeholder="请选择" size='mini' @change="changeApplyType();changeTableData();">
					<el-option v-for="item in [{label:'全部',value:'0'},{label:'猫',value:'1'},{label:'犬',value:'2'}]" :key='item.value' :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">品种:</span>
				<el-select style="width: 100px;" v-model="categoryId" placeholder="请选择" size='mini' @change="changeTableData">
					<el-option v-for="item in typeList" :key='item.id' :label="item.label" :value="item.id">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">性别:</span>
				<el-select style="width: 75px;" v-model="petSex" placeholder="请选择" size='mini' @change="changeTableData">
					<el-option v-for="item in [{label:'全部',value:''},{label:'公',value:'公'},{label:'母',value:'母'}]" :key='item.value' :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">颜色:</span>
				<el-select class="select" style="width:75px;" filterable v-model="color" placeholder="请选择毛色" size="mini" @change="changeTableData">
					<el-option v-for="item in colorList" :key="item._id" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">年龄:</span>
				<el-select style="width: 100px;" v-model="age" placeholder="请选择" size='mini' @change="changeTableData">
					<el-option v-for="item in [{label:'全部',value:''},{label:'0~3个月',value:'1'},{label:'3~6个月',value:'2'},{label:'6~9个月',value:'3'},{label:'9~12个月',value:'4'},{label:'大于12个月',value:'5'}]" :key='item.value' :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span style="padding-left:2px;">日期:</span>
				<el-date-picker v-model="pickerValue" type="daterange" @change="changeTableData" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" :clearable="false" style="width: 200px;">
				</el-date-picker>
				<el-button type="warning" size="mini" @click="reset" style="margin-left:10px;">重置</el-button>
			</div>
			<el-table :data="tableData" style="width: 100%;padding:20px;">
				<el-table-column prop="no" label="序号" min-width="40">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="门店" min-width="80">
					<template slot-scope="scope">
						{{scope.row.saleShop}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="入库时间" min-width="150">
					<template slot-scope="scope">
						{{scope.row.createDate}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="购买时间" min-width="150">
					<template slot-scope="scope">
						{{scope.row.saleDate}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="品种" min-width="80">
					<template slot-scope="scope">
						{{scope.row.category}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="性别"  min-width="60">
					<template slot-scope="scope">
						{{scope.row.sex}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="颜色" min-width="100">
					<template slot-scope="scope">
						{{scope.row.color}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="价格"  min-width="80">
					<template slot-scope="scope">
						{{scope.row.price}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="年龄" min-width="80">
					<template slot-scope="scope">
						{{scope.row.age}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="出生日期" min-width="100">
					<template slot-scope="scope">
						{{scope.row.bronDate}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="在店时长" min-width="100">
					<template slot-scope="scope">
						{{scope.row.inShopDays}}
					</template>
				</el-table-column>
				<el-table-column prop="no" label="活体订单" min-width="160">
					<template slot-scope="scope">
						{{scope.row.orderNO}}
					</template>
				</el-table-column>
			</el-table>
			<div style="background-color: #fff;padding-top:10px;">
				<page :total="page.total" :page="page.page" @change="changePage" style="padding-bottom: 10px;"></page>
			</div>
		</div>
	</div>
</template>
<script>
	import echarts from "echarts";
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				// tit
				curBtn1:'',
				curDate1: [],
				// panel1
				radio1:1,
				datas:{},
				// panel2
				curBtn2:'month',
				curDate2:'',
				// panel3
				radio3:0,
				shopId3:'',
				curShopDatas:{},
				// panel4
				shopId:'',
				applyType: "", // 1:猫用 2:犬用
				categoryId: "", // 分类编号
				typeList:[],
				typeList0:[],
				typeList1:[],
				typeList2:[],
				minPrice: '',
				maxPrice: '',
				petSex: "", // 公 母
				color: "全部", // 颜色
				colorList:[],
				age: "", // 年龄 1:0~3个月 2:3~6个月 3:6~9个月 4:9~12个月 5:大于12个月
				pickerValue:[],
				page:{
					pageIndex:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
				
				myChart0:null,
				myChart1:null,
			}
		},
		computed:{
			
		},
		created() {
			let shopList =  JSON.parse(JSON.stringify(this.$store.getters['shopList']));
			if(shopList[0]&&shopList[0].shop_name!=='全部'){
				shopList.unshift({shop_id:'',shop_name:'全部'})
			}
			this.shopList = shopList
			let now = new Date()
			let year = now.getFullYear()
			let month = now.getMonth()+1
			if(month<10){
				month = "0"+month
			}
			console.log(new Date(year+'-'+month+'-01'),year+'-'+month+'-01')
			this.curDate1 = [new Date(year+'-'+month+'-01'),now];
			this.curDate2 = now
			this.pickerValue = [new Date(year+'-'+month+'-01'),now];
			// this.getTrendDatas()
			this.getHuotiDatas();
			this.getTableData();
		},
		mounted() {
			this.myChart0 = echarts.init(document.getElementById("myChartHuoti0"));
			this.myChart1 = echarts.init(document.getElementById("myChartHuoti1"));
			let params = {
				category: '活体'
			}
			this.$http.get('/api/Product/Category/Tree', params).then(res => {
				if(res.code===0){
					let typelist1 = []
					let typelist2 = []
					for(let i=0;i<res.data[0].children.length;i++){
						let item = res.data[0].children[i];
						if(item.id==='603f7255664b790a9c7d4f61'){
							let a = [{label:'全部',id:''}];
							typelist1 = a.concat(item.children);
						}
						if(item.id==='603f7255664b790a9c7d4f62'){
							let b = [{label:'全部',id:''}];
							typelist2 = b.concat(item.children);
						}
					}
					let t1 = JSON.parse(JSON.stringify(typelist1))
					let t2 = JSON.parse(JSON.stringify(typelist2))
					t2.splice(0,1);
					this.typeList0 = t1.concat(t2)
					this.typeList1 = typelist1
					this.typeList2 = typelist2
					
					this.typeList = this.typeList0;
				}
			})
			this.getColorList();
		},
		methods: {
			changeShop(){
				this.clickSearch()
			},
			changePicker(val) {
				this.params.curDate1 = this.$public.FTimeStr10(val);
				this.clickSearch()
			},
			changeDateType(){
				this.clickSearch()
			},
			clickSearch() {
				this.getDatas();
			},
			// tit
			changeCurDate1(){
				console.log(this.curDate1)
				this.getHuotiDatas();
			},
			// panel1
			changeRadio1(){
				this.draw0()
			},
			// panel2
			// changeCurBtn2(str){
			// 	if(this.curBtn2!==str){
			// 		this.curBtn2 = str;
			// 		this.getTrendDatas()
			// 	}
				
			// },
			// changeCurDate2(){
			// 	this.getTrendDatas()
			// },
			// panel3
			changeShopId3(){
				for(let i=0;i<this.datas.shopPetSexSaleDetails.length;i++){
					if(this.datas.shopPetSexSaleDetails[i].shopId===this.shopId3){
						this.curShopDatas = this.datas.shopPetSexSaleDetails[i]
					}
				}
			},
			// panel4
			changeApplyType(){
				if(this.applyType==='1'){
					this.categoryId = ''
					this.typeList = this.typeList1
				}else if(this.applyType==='2'){
					this.categoryId = ''
					this.typeList = this.typeList2
				}else{
					this.categoryId = ''
					this.typeList = this.typeList0
				}
			},
			// 趋势图 chart
			// getTrendDatas(){
			// 	let params = {
			// 		month:this.$public.FTime(this.curDate2.getTime()/1000,'YYYY-MM'), //格式要求:2021-10
			// 		way:this.curBtn2==="month"?'0':'1', // 0:按月 1:按年
			// 	}
			// 	let loading = this.$loading()
			// 	this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/trend', params).then(res => {
			// 		loading.close()
			// 		this.$nextTick(()=>{
			// 			this.draw1(res.data)
			// 		})
			// 	})
			// },
			// 门店数量
			getHuotiDatas(){
				if(this.curDate1.length!==2){
					this.$message({
						message: '日期选择有误',
						type: 'error'
					});
					return ;
				}
				let params = {
					startTime:this.$public.FTimeStr10(this.curDate1[0]), // 
					endTime:this.$public.FTimeStr10(this.curDate1[1]),  //
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/highest/data', params).then(res => {
					loading.close()
					this.datas = res.data;
					this.shopId3 = '5e9412e0b2bfbc089daerr12'
					this.changeShopId3();
					this.changeRadio1()
					this.$nextTick(()=>{
						this.draw1(this.datas.trendMapData)
					})
				})
			},
			changeTableData(){
				this.page.pageIndex = 1
				this.getTableData()
			},
			changePage(num){
				this.page.pageIndex = num
				this.getTableData()
			},
			reset(){
				this.shopId = ''
				this.applyType = ''
				this.categoryId = ''
				this.minPrice = ''
				this.maxPrice = ''
				this.petSex = ''
				this.color = '全部'
				this.age = ''
				this.page.pageIndex = 1
				this.getTableData()
			},
			// 活体销售列表
			getTableData(){
				let startTime = ''
				let endTime = ''
				if(this.pickerValue.length===2){
					startTime = this.$public.FTimeStr10(this.pickerValue[0])
					endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
				}
				let params = {
					"pageIndex": this.page.pageIndex,
					"pageSize": this.page.pageSize,
					"shopId": this.shopId,
					"applyType": this.applyType, // 0:通用 1:猫用 2:犬用
					"categoryId": this.categoryId, // 分类编号
					"minPrice": Number(this.minPrice),
					"maxPrice": Number(this.maxPrice),
					"petSex": this.petSex, // 公 母
					"age": this.age, // 年龄 1:0~3个月 2:3~6个月 3:6~9个月 4:9~12个月 5:大于12个月
					"color": this.color=='全部'?'':this.color,
					"startTime": startTime,
					"endTime": endTime,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/list', params).then(res => {
					loading.close()
					this.tableData = res.data.data;
					this.page.total = res.data.count;
				})
			},
			draw0(){
				let arr = this.datas.shopPetSexSaleDetails
				if(this.radio1===0){
					let d = []
					for(let i=0;i<arr.length;i++){
						d.push({
							value:this.$public.jia(arr[i].catFemaleCount,arr[i].catMaleCount,arr[i].dogFemaleCount,arr[i].dogMaleCount), 
							name:arr[i].shopName,
						})
					}
					this.myChart0.setOption({
						color:['#F5882A','#58A2F7','#FBCB63','#F76260','#8167F5','#F5EC67','#28D3DB','#96D9FF'],
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							right: '30',
							top: 'middle',
							textStyle:{
								fontSize:'14',
								color: '#666',
								lineHeight:'30'
							},
							formatter:(e)=>{
								for(let i=0;i<d.length;i++){
									if(d[i].name===e){
										return e+'：'+d[i].value+'只'
									}
								}
							},
						},
						series: [
							{
								name: '访问来源',
								type: 'pie',
								radius: ['40%','75%'],
								center: [120,120],
								label: {
									position: 'inner',
									fontSize: 14,
									formatter:(val)=>{
										return val.percent+'%';
									}
								},
								data: d,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								tooltip:{
									formatter:(val)=>{
										return "<div>"+
											val.name+":"+val.value+"("+val.percent+"%)"+
											"<div style='padding-left:20px;'>"+
												"公猫:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].catMaleCount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"母猫:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].catFemaleCount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"公犬:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].dogMaleCount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"母犬:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].dogFemaleCount+
											"</div>"+
										"</div>"
									}
								}
							},
						]
					})
				}else{
					let d = []
					for(let i=0;i<arr.length;i++){
						d.push({
							value:this.$public.jia(arr[i].catFemaleAmount,arr[i].catMaleAmount,arr[i].dogFemaleAmount,arr[i].dogMaleAmount), 
							name:arr[i].shopName,
						})
					}
					this.myChart0.setOption({
						color:['#F5882A','#58A2F7','#FBCB63','#F76260','#8167F5','#F5EC67','#28D3DB','#96D9FF'],
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							right: '30',
							top: 'middle',
							textStyle:{
								fontSize:'14',
								color: '#666',
								lineHeight:'30'
							},
							formatter:(e)=>{
								for(let i=0;i<d.length;i++){
									if(d[i].name===e){
										return e+'：'+d[i].value+'元'
									}
								}
							},
						},
						series: [
							{
								name: '访问来源',
								type: 'pie',
								radius: ['40%','75%'],
								center: [120,120],
								label: {
									position: 'inner',
									fontSize: 14,
									formatter:(val)=>{
										return val.percent+'%';
									}
								},
								data: d,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								tooltip:{
									formatter:(val)=>{
										return "<div>"+
											val.name+":"+val.value+"("+val.percent+"%)"+
											"<div style='padding-left:20px;'>"+
												"公猫:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].catMaleAmount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"母猫:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].catFemaleAmount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"公犬:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].dogMaleAmount+
											"</div>"+
											"<div style='padding-left:20px;'>"+
												"母犬:"+arr.filter((item)=>{if(item.shopName===val.name){return item}})[0].dogFemaleAmount+
											"</div>"+
										"</div>"
									}
								}
							},
						]
					})
				}
				
			},
			draw1(obj){
				let x = obj.x
				let series = []
				for(let i=0;i<obj.datas.length;i++){
					let item = obj.datas[i]
					let d = []
					for(let a=0;a<item.values.length;a++){
						d.push(item.values[a].count)
					}
					item.data = d
					item.type = "line"
					// item.name = item.name
					item.tooltip = {
						formatter:(val)=>{
							return "<div>日期："+val.name+"</div>"+
								"<div>门店："+val.seriesName+"</div>"+
								"<div>数量："+val.data+"</div>"+
								"<div>金额："+series[val.componentIndex].values[val.dataIndex].amount+"</div>"
						}
					}
					series.push(item)
				}
				this.myChart1.setOption({
					color:['#F76260','#96D9FF','#FBCB63','#8167F5','#28D3DB','#F5EC67','#F5882A','#58A2F7'],
					legend: {right: '100',},
					tooltip: {
						trigger: 'item',
						// showContent: false
					},
					yAxis: {
						gridIndex: 0,
						type: 'value',
						name: '数量(只)',
					},
					grid: { top: '15%' },
					xAxis: {
						type: 'category',
						name: '日期',
						splitLine: { show: false },
						data: x,
					},
					series: series,
				})
			},
			// 获取毛色列表
			getColorList(){
				let params = {
					"keyword": "",
					"pageIndex": 1,
					"pageSize": 1000
				}
				this.$http.post('/api/DataCenter/List', params).then(res => {
					if (res.code == 0) {
						let arr = [{name:'全部',_id:''}]
						this.colorList = arr.concat(res.data.data);
					}
				})
			},
		},
		
	}
</script>
<style scoped lang="scss">
	.page {
		width:100%;
		.nucleustit {
			display: flex;justify-content: space-between;height: 57px;box-sizing: border-box;padding:16px 16px 0 16px;background-color: #fff;
			.tit {
				color: $fontColor;font-size: 18px;font-weight: bold;margin:4px 0;padding:0 6px;box-sizing: border-box;height: 20px;line-height: 20px;
			}
		}
		.panel1{
			width:443px;height: 326px;background-color: #fff;border-radius: 10px;margin-right: 12px;margin-top:12px;
			.tit{
				font-size: 18px;color:#333;padding:20px;display: flex;justify-content: space-between;
			}
		}
		.panel2{
			width:calc(100% - 455px);height: 326px;background-color: #fff;border-radius: 10px;margin-top:12px;
			.tit{
				font-size: 18px;color:#333;padding:20px;display: flex;justify-content: space-between;
				.btn{
					display: inline-block;font-size: 14px;color:#666;width:68px;border:1px solid #ddd;border-radius: 2px;line-height: 26px;text-align: center;cursor: pointer;margin-right: 20px;
					&.active{
						background-color: $mainColor;color:#fff;
					}
				}
			}
		}
		.panel3{
			width:100%;height: 290px;background-color: #fff;border-radius: 10px;margin-top:12px;
			.tit{
				font-size: 18px;color:#333;padding:20px;
			}
			.panel3Cell{
				width:100%;height: 168px;margin-right: 12px;border:1px solid #EAEDF7;box-shadow: 0px 2px 4px 0px rgba(28, 41, 90, 0.04);border-radius: 10px;padding:20px;box-sizing: border-box;display: flex;justify-content: space-around;
				.panel3CellL{
					display: inline-block;
					.panel3Cell1{
						font-size: 16px;color:#666;padding-top:15px;
					}
					.panel3Cell2{
						font-size: 32px;color:#242F57;padding:15px 0;
					}
					.panel3Cell3{
						font-size: 16px;color:#333;
					}
				}
				.panel3CellR{
					width:113px;display: inline-block;vertical-align:sub;
				}
			}
			.panel3Item{
				width:100%;height: 168px;margin-right: 12px;border:1px solid #EAEDF7;box-shadow: 0px 2px 4px 0px rgba(28, 41, 90, 0.04);border-radius: 10px;
				.panel3ItemTit{
					font-size: 16px;color:$fontColor;padding:16px 20px 9px;border-bottom:1px solid #EAEDF7;
				}
				.panel3ItemLine{
					padding:30px 20px 5px;font-size: 14px;color:$fontColor;display: flex;
				}
			}
		}
		.panel4{
			width:100%;height: 290px;background-color: #fff;border-radius: 10px;margin-top:12px;
			.tit{
				font-size: 18px;color:#333;padding:20px;
			}
		}
	}
</style>
